import type { FilterV2ActionHandler, IFilterItem } from "@next-platform/client-common-spicy-ui";
import type { Dispatch, SetStateAction } from "react";

import type { DisplayContext } from "../types";

export enum UpdateOptionsCharacter {
  TAG = "tag",
  LANGUAGE = "language",
  DEFINITION = "definition",
}

export type FilterOperator = "and" | "or";

export type FilterPanelCharacterProps = {
  context: DisplayContext | undefined;
  isDesktop: boolean;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  setFeaturesSlot: Dispatch<SetStateAction<HTMLDivElement | null>>;
  hasFilterDefinition: boolean;
  hasTagRefinements: boolean;
  tagRefinementCount: number;
  languageRefinementCount: number;
  definitionRefinementCount: number;
  chatSizeRefinementCount: number;
  tagsListData: IFilterItem[];
  tagsActionHandler: FilterV2ActionHandler;
  definitionListData: IFilterItem[];
  definitionActionHandler: FilterV2ActionHandler;
  languageListData: IFilterItem[];
  languageActionHandler: FilterV2ActionHandler;
  chatSizeListData: IFilterItem[];
  chatSizeActionHandler: FilterV2ActionHandler;
};
